<template>
  <div id="mySteelMall">
    <div
      style="
        width: 100%;
        height: 100%;
        background-color: #fafafa;
        margin-top: 32px;
        padding-bottom: 40px;
      "
    >
      <allMallSerch
        style="border-bottom: 1px solid #e6e6e6"
        ref="allMallSerch1"
      ></allMallSerch>
      <div class="mallMenuDiv">
        <nav>
          <div>
            <i
              class="icon iconfont iconclassify-on"
              style="font-size: 20px"
            ></i>
            <span class="m_l_10">全部商品分类</span>
          </div>
          <div class="nav_title">
            <span
              @click="switchType('首页')"
              :class="
                !showHelp &&
                !showXianhuo &&
                !showMach &&
                !showPurchase &&
                !isShowMyTransport
                  ? 'onNavSpan'
                  : ''
              "
              >首页</span
            >
            <span
              @click="switchType('现货商城')"
              :class="showXianhuo ? 'onNavSpan' : ''"
              >现货商城</span
            >
            <span
              @click="switchType('帮我采')"
              :class="showHelp ? 'onNavSpan' : ''"
              >帮我采</span
            >
            <span
              @click="switchType('帮我加工')"
              :class="showMach ? 'onNavSpan' : ''"
              >帮我加工</span
            >
            <span
              @click="switchType('帮我找货')"
              :class="showPurchase ? 'onNavSpan' : ''"
              >帮我找货</span
            >
            <span
              @click="helpMeTranslate"
              :class="isShowMyTransport ? 'onNavSpan' : ''"
              >帮我运</span
            >
          </div>
        </nav>
      </div>
      <div style="width: 1300px; margin: auto">
        <myTransport :from="'index'" v-if="isShowMyTransport"></myTransport>
        <myMachining
          :from="'index'"
          v-if="
            showMach &&
            !showXianhuo &&
            !showHelp &&
            !showPurchase &&
            !isShowMyTransport
          "
        ></myMachining>
        <searchResult
          :from="'index'"
          v-if="showHelp && !showXianhuo && !showMach"
          :showHelp="showHelp && !isShowMyTransport"
          :nohead="true"
        ></searchResult>
        <SteelMallResult
          :from="'index'"
          v-if="
            showXianhuo &&
            !showHelp &&
            !showPurchase &&
            !showMach &&
            !isShowMyTransport
          "
          :showXianhuo="showXianhuo"
          :nohead="true"
        ></SteelMallResult>
        <purchaseRelease
          :from="'index'"
          v-if="
            showPurchase &&
            !showHelp &&
            !showXianhuo &&
            !showMach &&
            !isShowMyTransport
          "
        ></purchaseRelease>
        <div
          v-show="
            !showHelp &&
            !showXianhuo &&
            !showPurchase &&
            !showMach &&
            !isShowMyTransport
          "
        >
          <nav class="mallTopNav" style="box-shadow: #eeeeee 4px 4px 15px">
            <div class="p_r">
              <ul>
                <li
                  v-if="index < 7"
                  :key="index"
                  v-for="(item, index) in allCategoryfatherList"
                >
                  <p>{{ item.name }}</p>
                  <div class="NoWrap">
                    <span v-if="item.childList[0]">{{
                      item.childList[0].name
                    }}</span>
                    <span v-if="item.childList[1]">{{
                      item.childList[1].name
                    }}</span>
                    <span v-if="item.childList[2]">{{
                      item.childList[2].name
                    }}</span>
                  </div>
                  <section class="materialTopLeft">
                    <p>{{ item.name }}</p>
                    <dl
                      style="border-bottom: 1px solid #eee; margin-bottom: 10px"
                    >
                      <dd
                        @click="toUrl('SteelMallResult', lastItem)"
                        :key="lastIndex"
                        v-for="(lastItem, lastIndex) in item.childList"
                      >
                        {{ lastItem.name }}
                      </dd>
                    </dl>
                    <p>材质</p>
                    <dl
                      style="border-bottom: 1px solid #eee; margin-bottom: 10px"
                    >
                      <dd
                        @click="toUrl('SteelMallResult', lastItem, 1)"
                        :key="lastIndex"
                        v-for="(lastItem, lastIndex) in MaterialQualityList"
                      >
                        {{ lastItem.name }}
                      </dd>
                    </dl>
                    <p>产地</p>
                    <dl>
                      <dd
                        @click="toUrl('SteelMallResult', lastItem, 2)"
                        :key="lastIndex"
                        v-for="(lastItem, lastIndex) in chandiList"
                      >
                        {{ lastItem.name }}
                      </dd>
                    </dl>
                  </section>
                </li>
              </ul>
            </div>
            <div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  height: 100%;
                  overflow: hidden;
                  width: 100%;
                "
              >
                <imgScorll
                  v-if="showImg"
                  :linkList="linkList"
                  :imgList="bannerList"
                ></imgScorll>
              </div>
            </div>
            <div>
              <div>
                <nav>
                  <div class="topInfoDiv f">
                    <div>
                      <img
                        style="border-radius: 100px"
                        src="../../../../assets/img/Avatar01.png"
                      />
                    </div>
                    <span class="font12 f_w NoWrap"
                      ><span v-if="!isRegister">Hi</span>
                      <span v-else>{{ MemberInfo.name }}</span>
                      <span>，您好！</span></span
                    >
                  </div>
                  <div class="d_flex topInfoDivBt">
                    <button
                      v-if="isRegister"
                      @click="$commonJs.loginOut('')"
                      class="cancelButton"
                    >
                      <span>退出登录</span>
                    </button>
                    <button
                      v-if="isRegister"
                      @click="toCenterUrl('myProductList')"
                      class="cancelButton"
                    >
                      <span>我的合同</span>
                    </button>
                    <button
                      @click="toLogin"
                      v-if="!isRegister"
                      class="cancelButton"
                    >
                      <span>&nbsp; 登录 &nbsp;</span>
                    </button>
                    <button
                      v-if="!isRegister"
                      @click="toCenterUrl('register')"
                      class="cancelButton"
                    >
                      <span>&nbsp; 注册 &nbsp;</span>
                    </button>
                  </div>
                </nav>
                <div class="topNoticeDiv">
                  <nav>
                    <span
                      @click="selectNoticeIndex = 1"
                      :class="
                        selectNoticeIndex === 1 ? 'onTopNoticeDivSpan' : ''
                      "
                      >百钢头条</span
                    >
                    <span
                      @click="selectNoticeIndex = 0"
                      v-if="isRegister"
                      :class="
                        selectNoticeIndex === 0 ? 'onTopNoticeDivSpan' : ''
                      "
                      >平台通知</span
                    >
                  </nav>
                  <dl v-show="selectNoticeIndex === 1">
                    <dd
                      @click="getNoticeDetail(item)"
                      :key="index"
                      v-for="(item, index) in noticeList"
                    >
                      <span :title="item.title" class="NoWrap">{{
                        item.title
                      }}</span>
                      <span class="NoWrap">{{
                        item.createTime.split(" ")[0]
                      }}</span>
                    </dd>
                  </dl>
                  <dl
                    style="min-height: 135px"
                    v-show="selectNoticeIndex === 0 && isRegister"
                  >
                    <dd
                      @click="getPlatNotice(item)"
                      :key="index"
                      v-for="(item, index) in myMessageList"
                    >
                      <span class="NoWrap">{{ item.content }}</span>
                      <span class="NoWrap">{{
                        item.createTime.split(" ")[0]
                      }}</span>
                    </dd>
                  </dl>
                </div>
                <div class="topRightNineMenuDiv">
                  <ul>
                    <li
                      @click="toUrl2(item)"
                      :key="index"
                      v-for="(item, index) in myTopRightList"
                    >
                      <div><i :class="item.icon"></i></div>
                      <p>{{ item.name }}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
          <div
            style="margin-top: 20px"
            v-if="isRegister && couponList.length > 0"
          >
            <nav class="p_L_10 font16 f_w">
              <span class="l_Vertical">领取优惠券</span>
            </nav>
            <div class="allUl_bUl">
              <div class="couponDiv">
                <dl>
                  <dd
                    @click="getCoupon(coupItem)"
                    :key="coupIndex"
                    v-for="(coupItem, coupIndex) in couponList"
                  >
                    <div class="b_c_rede1251b colorWhite">
                      <p class="d_flex m_b_10">
                        <span
                          class="font16"
                          v-if="parseInt(coupItem.type) === 2"
                        >
                          <span class="font22"
                            >{{ coupItem.couponValue }}元</span
                          >
                          <span class="font12">满{{ coupItem.threshold }}</span>
                        </span>
                        <span
                          class="font16"
                          v-if="parseInt(coupItem.type) === 3"
                        >
                          <span class="font22"
                            >{{ coupItem.couponValue }}折</span
                          >
                          <span class="font12">满{{ coupItem.threshold }}</span>
                        </span>
                        <span>限领 {{ coupItem.receiveLimit }}张</span>
                      </p>
                      <p>
                        有效期至{{
                          $commonJs.returnNewDate(coupItem.endTime, "YYMMDD")
                        }}
                      </p>
                    </div>
                    <div class="p_r" style="overflow: hidden">
                      <span
                        class="colorGray959595"
                        v-if="parseInt(coupItem.goodScope) === 1"
                        >[全商品]</span
                      >
                      <span
                        class="colorGray959595"
                        v-if="parseInt(coupItem.goodScope) === 2"
                        >[部分商品]</span
                      >
                      <span
                        class="colorGray959595"
                        v-if="parseInt(coupItem.type) === 2"
                        >[满减券]</span
                      >
                      <span
                        class="colorGray959595"
                        v-if="parseInt(coupItem.type) === 3"
                        >[打折券]</span
                      >
                      <div class="onCouSel">
                        <span
                          style="
                            transform: rotate(45deg);
                            position: relative;
                            right: 2px;
                            bottom: 4px;
                          "
                          class="dis_line"
                          >领</span
                        >
                      </div>
                    </div>
                    <!--                    <section class="font12">-->
                    <!--                      <i class="icon iconfont icontishi" style="font-size: 12px"></i>-->
                    <!--                      <span class="colorGray959595 m_l_5">所结算商品中没有符合条件的商品</span>-->
                    <!--                    </section>-->
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="latestPriceDiv box_sd_15">
            <nav>
              <div>
                <i
                  class="icon iconfont iconshangsheng colorRedC73343 f_w"
                  style="font-size: 20px"
                ></i>
                <span class="font18 f_w">今日钢价</span>
              </div>
              <div class="colorGray696969">
                {{ $commonJs.returnDate($commonJs.todayDate, "YYMMDDheng") }}
              </div>
              <div
                style="white-space: nowrap; overflow-y: hidden"
                class="gangJiaModal"
              >
                <span
                  class="c_p"
                  @click="gethangqingList(null, '')"
                  :class="cityIndex === '' ? 'onlatestPriceDiv_span' : ''"
                  >全部</span
                >
                <span
                  class="c_p"
                  @click="gethangqingList(item.cityCode, index)"
                  v-for="(item, index) in CityAllList"
                  :key="index"
                  :class="cityIndex === index ? 'onlatestPriceDiv_span' : ''"
                  >{{ item.cityName }}</span
                >
              </div>
            </nav>
            <div class="latestWdDiv">
              <ul
                @mouseenter="isMove = false"
                @mouseleave="isMove = true"
                id="moveLeft"
                :style="{ transform: 'translateX(-' + moveLeft + 'px)' }"
              >
                <li
                  v-for="(item, index) in hangqingList"
                  :key="index"
                  class="p_r hoverShadow"
                >
                  <span>{{ item.name }}</span>
                  <div>
                    <p class="m_b_10">
                      <span class="font16"
                        >{{ item.categoryName }} {{ item.steelMillName }}</span
                      ><br />
                      <span class="font12 colorGray696969">{{ item.spec }}</span
                      ><br />
                    </p>
                    <p class="colorRedC73343">
                      <span class="font24">{{ item.price }}</span>
                      <i
                        v-if="item.fluctuate"
                        class="icon iconfont iconsheng m_l_10 m_r_10"
                      ></i>
                      <span>{{ item.fluctuate || "" }}</span>
                    </p>
                  </div>
                  <!--                <div>-->
                  <!--                  <p class="m_b_10">-->
                  <!--                    <span class="font16">三级螺纹钢 申特</span><br/>-->
                  <!--                    <span class="font12 colorGray696969">22*9</span><br/>-->
                  <!--                  </p>-->
                  <!--                  <p class="colorRedC73343">-->
                  <!--                    <span class="font24">6600</span>-->
                  <!--                    <i class="icon iconfont iconsheng m_l_10 m_r_10"></i>-->
                  <!--                    <span>+20</span>-->
                  <!--                  </p>-->
                  <!--                </div>-->
                </li>
              </ul>
              <div
                class="t_c"
                style="padding: 50px"
                v-if="hangqingList.length === 0"
              >
                <abbr class="colorGray959595">暂无行情数据</abbr>
              </div>
            </div>
          </div>
          <div class="bgServiceDiv b_fff box_sd_15 p_30_20">
            <nav class="" style="margin-bottom: 20px">
              <span class="font20 m_r_10 f_w">百钢服务</span>
              <span
                class="colorGray696969 m_l_10"
                style="vertical-align: bottom"
                >客服热线: 0512-57667666（8:30-17:30）</span
              >
            </nav>
            <dl>
              <dt
                @click="toSearch('search')"
                class="hoverShadow"
                style="margin-right: 20px"
              >
                <div
                  style="
                    background: linear-gradient(to right, #bb72ff, #9222fa);
                  "
                >
                  <p class="font28 m_b_20">百钢一下</p>
                  <p class="m_b_10 font18 NoWrap">快速响应，无需等待</p>
                  <p class="NoWrap font18">操作简单，上手方便</p>
                </div>
                <div class="t_c">点我搜索</div>
              </dt>
              <!--            <dd>-->
              <!--              <p class="m_b_20">-->
              <!--                <span class="font20 f_w">开平</span>-->
              <!--                <span class="m_l_10 font16" style="vertical-align: text-top">专业开平 高效加工</span>-->
              <!--              </p>-->
              <!--              <p class="NoWrap m_b_10">大平:厚度:4~16mm费用:20元每吨起</p>-->
              <!--              <p class="NoWrap">大平:厚度:4~16mm费用:20元每吨起</p>-->
              <!--              <div class="d_flex">-->
              <!--                <button style="background-color: #31c7c5">我要开平</button>-->
              <!--                <img src="../../../../assets/img/mall_07.png" height="80" width="80"/>-->
              <!--              </div>-->
              <!--            </dd>-->
              <dt
                @click="toCenterUrl('myProcessing')"
                class="hoverShadow"
                style="margin-right: 20px"
              >
                <div
                  style="
                    background: linear-gradient(to right, #ff9694, #d71e1e);
                  "
                >
                  <p class="font28 m_b_20">帮我加工</p>
                  <p class="m_b_10 font18 NoWrap">高效加工，精益求精</p>
                  <p class="NoWrap font18">需求万变，品质不变</p>
                </div>
                <div class="t_c">点我加工</div>
              </dt>
              <!--            <dd>-->
              <!--              <p class="m_b_20">-->
              <!--                <span class="font20 f_w">镀锌</span>-->
              <!--                <span class="m_l_10 font16" style="vertical-align: text-top">专业开平 高效加工</span>-->
              <!--              </p>-->
              <!--              <p class="NoWrap m_b_10">大平:厚度:4~16mm费用:20元每吨起</p>-->
              <!--              <p class="NoWrap">大平:厚度:4~16mm费用:20元每吨起</p>-->
              <!--              <div class="d_flex">-->
              <!--                <button style="background-color: #6ec5fc">我要开平</button>-->
              <!--                <img src="../../../../assets/img/mall_07.png" height="80" width="80"/>-->
              <!--              </div>-->
              <!--            </dd>-->
              <dt @click="toCenterUrl('purchaseRelease')" class="hoverShadow">
                <div>
                  <p class="font28 m_b_20">帮我找货</p>
                  <p class="m_b_10 font18 NoWrap">货源服务，领先一步</p>
                  <p class="NoWrap font18">你来我网，货源共享</p>
                </div>
                <div class="t_c">点我找货</div>
              </dt>
            </dl>
          </div>
          <div class="mallBreDiv b_fff box_sd_15 p_30_20">
            <nav class="d_flex">
              <div class="m_b_10">
                <span class="font20 m_r_10 f_w">钢材</span>
                <!--              <span class="colorGray696969 m_l_10" style="vertical-align: bottom">H型钢9：00开售</span>-->
              </div>
              <div @click="openResult">
                <span class="font20 m_r_10 colorGray696969 c_p"
                  >去商城选购</span
                >
                <i
                  class="icon iconfont icondouble-arrow-left1 colorGray696969"
                ></i>
              </div>
            </nav>
            <div>
              <div style="background-color: #5fc0c7">
                <p class="font24">{{ firstCate.name }}</p>
                <img
                  src="../../../../assets/img/mall_08.png"
                  width="90%"
                  style="margin-top: calc(95% - 10px)"
                  class="m_b_10"
                />
                <!--              <p class="twoWarp">{{ firstCate.name }}</p>-->
              </div>
              <div>
                <ul class="no-ul">
                  <li
                    @click="openGoodDetail(item)"
                    :key="index"
                    v-for="(item, index) in firstCateList"
                  >
                    <div class="d_flex m_b_20">
                      <div>
                        <span class="colorYellow font16 f_w">{{
                          item.name
                        }}</span>
                        <span class="colorGray959595"
                          >{{ item.originPlaceName }}
                          {{ item.steelMillName }}</span
                        >
                      </div>
                      <span
                        @click.stop="showDetailFun(item)"
                        style="text-decoration: underline"
                        class="colorBlue4b8fc4"
                        >{{ item.warehouseName }}</span
                      >
                    </div>
                    <p class="m_b_10">
                      {{ item.guige }} - {{ item.materialQualityName }} -
                      {{ item.lisuanWeight }}t
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="mallBreDiv b_fff box_sd_15 p_30_20">
            <nav class="d_flex">
              <div class="m_b_10">
                <span class="font20 m_r_10 f_w" style="">其他品类推荐</span>
              </div>
              <div @click="openResult">
                <span class="font20 m_r_10 colorGray696969 c_p"
                  >去商城选购</span
                >
                <i
                  class="icon iconfont icondouble-arrow-left1 colorGray696969"
                ></i>
              </div>
            </nav>
            <div>
              <div style="background-color: #cfcfcf">
                <p class="font24">其他</p>
                <img
                  src="../../../../assets/img/mall_07.png"
                  width="90%"
                  style="margin-top: calc(95% - 10px)"
                  class="m_b_10"
                />
              </div>
              <div>
                <ul class="no-ul">
                  <li
                    @click="openGoodDetail(item)"
                    :key="index"
                    v-for="(item, index) in secCateList"
                  >
                    <div class="d_flex m_b_20">
                      <div>
                        <span class="colorYellow font16 f_w">{{
                          item.name
                        }}</span>
                        <span class="colorGray959595"
                          ><span class="color000 f_w">{{
                            item.categorySecondName
                          }}</span>
                          <span>{{ item.originPlaceName }}</span>
                          <span>{{ item.steelMillName }}</span></span
                        >
                      </div>
                      <span
                        @click.stop="showDetailFun(item)"
                        style="text-decoration: underline"
                        class="colorBlue4b8fc4"
                        >{{ item.warehouseName }}</span
                      >
                    </div>
                    <p class="m_b_10">
                      {{ item.guige }} - {{ item.materialQualityName }} -
                      {{ item.lisuanWeight }}t
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="mallMarketDiv b_fff box_sd_15">
            <div>
              <p class="f_w font20 colorRedC73343">现货市场</p>
              <div class="cargodiv">
                <ul>
                  <li class="hoverShadow">
                    <p class="font20 colorRedC73343">现货商城</p>
                    <p class="font18 f_w">{{ randomFuture.cateName }}</p>
                    <div>
                      <p
                        @click="openGoodDetail(item)"
                        class="hover2"
                        :key="index"
                        v-for="(item, index) in randomFuture.list"
                      >
                        <span>{{ item.name }}</span
                        ><abbr>{{ item.guige }}</abbr>
                      </p>
                    </div>
                  </li>
                  <li class="hoverShadow">
                    <p class="font20 colorRedC73343">现货商城</p>
                    <p class="font18 f_w">{{ randomFuture2.cateName }}</p>
                    <div>
                      <p
                        @click="openGoodDetail(item)"
                        class="hover2"
                        :key="index"
                        v-for="(item, index) in randomFuture2.list"
                      >
                        <span>{{ item.name }}</span
                        ><abbr>{{ item.guige }}</abbr>
                      </p>
                    </div>
                  </li>
                  <li class="hoverShadow">
                    <p class="font20 colorRedC73343">现货商城</p>
                    <p class="font18 f_w">{{ randomFuture3.cateName }}</p>
                    <div>
                      <p
                        @click="openGoodDetail(item)"
                        class="hover2"
                        :key="index"
                        v-for="(item, index) in randomFuture3.list"
                      >
                        <span>{{ item.name }}</span
                        ><abbr>{{ item.guige }}</abbr>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <p class="p_s f_w font20 colorRedC73343">交易动态</p>
              <div>
                <ul>
                  <li
                    v-for="(item, index) in tradingNewsList"
                    :key="'trad' + index"
                  >
                    <p class="d_flex m_b_10">
                      <span class="f_w">{{
                        item.orderGoodList.length > 0
                          ? item.orderGoodList[0].name
                          : "暂无数据"
                      }}</span>
                      <span class="colorRede31d1a f_w"
                        >￥{{ item.totalAmt }}</span
                      >
                    </p>
                    <p class="d_flex t_l">
                      <span class="f_w">{{
                        item.orderGoodList.length > 0
                          ? item.orderGoodList[0].skuName
                          : "暂无数据"
                      }}</span>
                      <span class="colorGray959595">{{ item.createTime }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="mallOptimalDiv b_fff box_sd_15 p_30_20">
            <nav class="d_flex">
              <span class="f_w colorRede31d1a font20">优选精选</span>
              <!-- <div style="width: 80%">
                <div
                  :key="index"
                  v-for="(item, index) in myOptimalList"
                  style="display: inline-block"
                >
                  <input
                    type="radio"
                    class="optimalDiv"
                    :id="'optimalRadio' + index"
                    v-model="optimaID"
                    :value="item.id"
                    name="optimaloptimalRadio"
                  />
                  <label :for="'optimalRadio' + index" class="optimalLable">{{
                    item.name
                  }}</label>
                </div>
              </div>
              <span class="f_w c_p">更多</span> -->
            </nav>
            <div class="optimalTabDiv">
              <ul id="jingxuanList"></ul>
            </div>
          </div>
          <div class="btXinxi">
            <table width="100%">
              <tr>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_06.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">资源</p>
                    <p class="font12 colorGray959595">一键输入<br />资源到手</p>
                  </div>
                </td>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_04.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">产融</p>
                    <p class="font12 colorGray959595">
                      放大您的购买力<br />绝不错过任何商机
                    </p>
                  </div>
                </td>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_02.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">仓库</p>
                    <p class="font12 colorGray959595">
                      视频监控安全可靠<br />配套齐全
                    </p>
                  </div>
                </td>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_03.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">加工</p>
                    <p class="font12 colorGray959595">
                      专业加工定制化服务<br />打造您的专属装备
                    </p>
                  </div>
                </td>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_05.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">运输</p>
                    <p class="font12 colorGray959595">
                      快捷轻松服务贴心<br />诚心保证
                    </p>
                  </div>
                </td>
                <td>
                  <div class="m_r_10">
                    <img
                      src="../../../../assets/img/mall_01.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <p class="f_w">用户</p>
                    <p class="font12 colorGray959595">
                      快捷高效<br />您的满意是我们的追求
                    </p>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="btService" style="border-top: 2px solid #eeeeee">
        <table class="t_c" style="width: 1360px; margin: 0 auto">
          <tr>
            <td
              class="t_l p_r"
              width="300"
              style="padding: 40px 80px 40px 40px; box-sizing: border-box"
            >
              <div class="btServiceLogo">
                <img
                  src="../../../../assets/img/topLog2.png"
                  alt=""
                  style="width: 250px; margin-top: 20px"
                />
              </div>
              <!--              <div class="m_t_20 t_l m_l_10">-->
              <!--                <img src="../../../../assets/img/phone.png" alt="" style="width: 16px;" class="d_l v_m">-->
              <!--                <span style="" class="c_8b90 font18 m_l_10 d_l v_m">0512-57667666</span>-->
              <!--              </div>-->
              <!--              <h1 class="colorWhite font24">百钢商城</h1>-->
              <!--              <p class="colorWhite font12">BAIGANG STEEL</p>-->
              <!--              <span class="dis_line" style="width: 100%;height: 1px;background-color: #696969"/>-->
              <!--              <p class="colorGray959595 font12 m_b_10">24小时客服热线</p>-->
              <!--              <p class="colorWhite">400-101-8958</p>-->
            </td>
            <td
              :key="index"
              v-for="(item, index) in helpList"
              style="padding: 40px 0; box-sizing: border-box"
            >
              <p class="c_8b90 font18 m_b_10 t_l">
                <i v-if="index === 0" class="icon iconfont iconzhinan"></i>
                <i v-if="index === 1" class="icon iconfont iconmaijiaxinxi"></i>
                <i v-if="index === 2" class="icon iconfont iconmaijia"></i>
                <span class="m_l_10">{{ item.type }}</span>
              </p>
              <p
                class="hover2 c_8b90 t_l"
                style="font-size: 14px; margin-left: 30px"
                @click="toHelp(item, childItem)"
                :key="childIndex"
                v-for="(childItem, childIndex) in item.childrenList"
              >
                {{ childItem.question }}
              </p>
            </td>
            <!--            <td  width="130">-->
            <!--              <img src="../../../../assets/img/shangcheng.jpg"  width="100"/>-->
            <!--              <p style="margin-top: 10px;" class="c_8b90">百钢商城</p>-->
            <!--            </td>-->
            <!--            <td  width="130">-->
            <!--              <img src="../../../../assets/img/baigangSearch.jpg"  width="100"/>-->
            <!--              <p style="margin-top: 10px;" class="c_8b90">百钢网小程序</p>-->
            <!--            </td>-->

            <td width="300" style="padding: 40px 0; box-sizing: border-box">
              <p class="c_8b90 t_l" style="font-size: 16px">
                <span>咨询热线：</span>
                <span class="m_l_10">0512-57667666</span>
              </p>
              <p class="c_8b90 t_l m_t_20" style="font-size: 16px">
                <span>工作时间：</span>
                <span class="m_l_10">周一至周日8:00-17:00</span>
              </p>
              <p class="c_8b90 t_l m_t_20" style="font-size: 16px">
                <span>客服邮箱：</span>
                <span class="m_l_10">kefu@baigang.com</span>
              </p>
            </td>
            <td
              width="130"
              style="
                padding: 20px;
                box-sizing: border-box;
                background-color: #d71e1e;
              "
            >
              <img src="../../../../assets/erweima.png" style="width: 130px" />
              <p style="margin: 10px 0 0" class="c_fff">欢迎关注百钢</p>
              <p style="margin: 6px 0 0" class="c_fff">公众号</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!--    <div style="position: fixed;left: 0;right: 0;bottom: 0;top: 0">-->
    <!--      <div style="position: fixed;width: 200px;height: 50px;right: 250px;top: 60px;box-shadow: 0 0 9999px 9999px #333;opacity: 0.5;z-index: 99"></div>-->
    <!--      <div style="position: fixed;max-width: 500px;right: 250px;top: 300px;z-index: 100;color: #fff">-->
    <!--        <img width="100%" src="https://baigang.oss-cn-shanghai.aliyuncs.com/goodLife/1603808576932-b25c7360-d67c-4cdb.png"/>测试-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="mallPointToDiv">
      <a class="kefuHover">
        <div>
          <p><i class="icon iconfont iconkefu"></i></p>
          <p>在线客服</p>
        </div>
      </a>
      <div class="p_a kefuPlace">
        <div>
          <span style="letter-spacing: 2px" class="font18 colorRede31d1a"
            >在线客服</span
          ><span class="m_l_10 f_w font16">0512-57667666</span>
        </div>
        <div class="font12 m_b_5 color888">
          <span>服务时间:</span><span>周一至周日8：00-17：00</span>
        </div>
        <div
          class="font18 color666"
          style="border-top: 1px solid #eee; padding: 5px 0"
        ></div>
        <div>
          <!--<span class=" c_p">-->
          <!--  <a target="_blank" class="hover2" href="http://wpa.qq.com/msgrd?v=3&uin=80802170&site=qq&menu=yes">-->
          <!--    QQ客服1-->
          <!--  </a>-->
          <!--  </span><span class="m_l_20 c_p">-->
          <!--   <a target="_blank" class="hover2" href="http://wpa.qq.com/msgrd?v=3&uin=80835075&site=qq&menu=yes">-->
          <!--    QQ客服2-->
          <!--  </a>-->
          <!--</span>-->
          <img src="../../../../assets/img/baigangKefu.png" width="100%" />
        </div>
      </div>
      <a @click="toSearch('search')">
        <div>
          <p>百钢一下</p>
        </div>
      </a>
      <a @click="toCenterUrl('myProcessing')">
        <div>
          <p>帮我加工</p>
        </div>
      </a>
      <a @click="toCenterUrl('purchaseRelease')">
        <div>
          <p>帮我找货</p>
        </div>
      </a>
      <!--      <a>-->
      <!--        <div>-->
      <!--          <p>我的店铺</p>-->
      <!--        </div>-->
      <!--      </a>-->
      <a @click="toTop">
        <div>
          <p>
            <i class="icon iconfont iconicon- f_w" style="font-size: 18px"></i>
          </p>
          <p>回到顶部</p>
        </div>
      </a>
    </div>
    <model
      v-if="showNoticeDetail"
      onButton="'4’"
      :title="'公告详情'"
      :minWidth="'500px'"
      v-on:on-cancel="showNoticeDetail = false"
      v-on:on-confirm="showNoticeDetail = false"
    >
      <div style="padding: 20px">
        <div class="f_w font18">{{ noticeDetail.title }}</div>
        <div class="color666 font12">{{ noticeDetail.createTime }}</div>
        <div style="margin: 10px 0">{{ noticeDetail.content }}</div>
      </div>
    </model>
    <model
      v-if="showPlatNotice"
      onButton="'4’"
      :title="'平台通知'"
      :minWidth="'500px'"
      v-on:on-cancel="showPlatNotice = false"
      v-on:on-confirm="showPlatNotice = false"
    >
      <div style="padding: 20px">
        <div class="f_w font18">{{ platNotice.title }}</div>
        <div class="color666 font12">{{ platNotice.createTime }}</div>
        <div style="margin: 10px 0">{{ platNotice.content }}</div>
      </div>
    </model>
    <div v-show="showDetail2">
      <div style="opacity: 0.5" class="cover"></div>
      <div
        style="
          text-align: center;
          position: fixed;
          top: calc((100% - 670px) / 2.6);
          background-color: #fff;
          left: calc(50% - 350px);
          width: 700px;
          z-index: 1001;
        "
      >
        <div style="width: 100%; height: 600px" id="container"></div>
        <button
          @click="showDetail2 = false"
          style="margin: 20px"
          class="cancelButton"
        >
          返回
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../../../assets/js/pubilshSet'
import searchResult from '../searchResult'
import SteelMallResult from '../mySteelMall/SteelMallResult'
import purchaseRelease from '../mySteelMall/purchaseRelease'
import myMachining from '../mySteelMall/myMachining'
import myTransport from '../mySteelMall/myTransport'
let timeInter
let marker
let map
let youxuanTime
export default {
  name: 'mySteelMall',
  data () {
    return {
      isRegister: window.localStorage.getItem('memberId'),
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      baigangToken: localStorage.getItem('baigangToken') || '',
      isShowMyTransport: false,
      showMach: false,
      showHelp: false,
      showXianhuo: false,
      showPurchase: false,
      MaterialQualityList: [],
      chandiList: [],
      selectNoticeIndex: 1,
      noticeDetail: {},
      platNotice: {},
      couponList: [],
      cityIndex: '',
      showImg: false,
      isMove: true,
      showDetail2: false,
      moveLeft: 0,
      hangqingList: [],
      showNoticeDetail: false,
      showPlatNotice: false,
      linkList: [],
      helpList: [],
      WarehouseList: [],
      CityAllList: [],
      firstCateList: [],
      secCateList: [],
      randomFuture: {
        cateName: '',
        list: []
      },
      randomFuture2: {
        cateName: '',
        list: []
      },
      randomFuture3: {
        cateName: '',
        list: []
      },
      bannerList: [
      ],
      myTopRightList: [
        {
          id: 1,
          name: '查余额',
          icon: 'icon iconfont iconyue',
          url: pubilshSet.userCenterHostUrl + 'moneyManager'
        },
        {
          id: 2,
          name: '查仓库',
          icon: 'icon iconfont iconcangku',
          url: pubilshSet.searchHostUrl + 'searchWareHouse'
        },
        {
          id: 5,
          name: '查材料',
          icon: 'icon iconfont iconchedui',
          url: pubilshSet.searchHostUrl + 'searchMaterialQualityList'
        },
        {
          id: 3,
          name: '查发票',
          icon: 'icon iconfont iconfapiao',
          url: pubilshSet.userCenterHostUrl + 'invoiceManage'
        },
        {
          id: 4,
          name: '找加工',
          icon: 'icon iconfont iconshaxianjiagong',
          url: pubilshSet.userCenterHostUrl + 'myProcessing'
        },
        {
          id: 6,
          name: '提求购',
          icon: 'icon iconfont iconjianyi',
          url: pubilshSet.userCenterHostUrl + 'purchaseManage'
        }
      ],
      firstCate: {},
      myOptimalList: [
        {
          id: '',
          name: '全部'
        },
        {
          id: '1',
          name: '建材'
        },
        {
          id: '2',
          name: '钢材'
        },
        {
          id: '3',
          name: '木材'
        }
      ],
      optimaID: '',
      postCategoryData: {
        level: '',
        parentId: ''
      },
      noticeList: [],
      myMessageList: [],
      allCategoryList: [],
      allCategoryfatherList: [],
      tradingNewsList: []
    }
  },
  created () {
    document.title = '首页 | 百钢商城 | 钢铁电商，百炼成钢'
    this.getCategoryList(1)
    this.getBannerList()
    this.gethangqingList()
    this.getNotice()
    this.getRamdonList2(9)
    this.getTradingNews()
    this.getHangqingCityAllList()
    this.$axiox.post('/baigang/app/good/queryMaterialQualityList', { name: '', currPage: 1, pageSize: 9999 }).then(p => {
      this.MaterialQualityList = p.data.list
    })
    this.$axiox.post('/baigang/app/good/queryOriginPlaceList', { name: '', currPage: 1, pageSize: 9999 }).then(p => {
      this.chandiList = p.data.list
    })
    if (this.isRegister) {
      this.getMyMessage()
    }
    this.$axiox.post('/baigang/app/good/queryWarehouseList', { currPage: 1, pageSize: 9999 }).then(p => {
      this.WarehouseList = p.data.list
    })
    setTimeout(p => {
      this.getHelpList()
    }, 2000)
    // console.log(this.getRamdonList(6))
    if (this.isRegister) {
      this.getCouponList()
    }
  },
  mounted () {
    if (this.$route.query.type) {
      this.routeChange()
    }
    this.getRamdonList4(9)
  },
  destroyed () {
    clearInterval(timeInter)
    clearInterval(youxuanTime)
  },
  components: {
    myTransport,
    myMachining,
    searchResult,
    purchaseRelease,
    SteelMallResult
  },
  methods: {
    refreshShopCar () {
      this.$refs.allMallSerch1.getShopList()
    },
    routeChange () {
      if (this.$route.query.type) {
        if (this.$route.query.type === 'showXianhuo') {
          this.switchType('现货商城', 'route')
        } else if (this.$route.query.type === 'showHelp') {
          this.switchType('帮我采', 'route')
        } else if (this.$route.query.type === 'showMach') {
          this.switchType('帮我加工', 'route')
        } else if (this.$route.query.type === 'showPurchase') {
          this.switchType('帮我找货', 'route')
        } else if (this.$route.query.type === 'isShowMyTransport') {
          this.switchType('帮我运', 'route')
        }
        // isShowMyTransport
      } else {
        this.switchType('首页', 'route')
      }
    },
    switchType (type, from) {
      document.title = type + ' | 百钢商城 | 钢铁电商，百炼成钢'
      // console.log(type, from)
      this.$forceUpdate()
      if (type === '首页') {
        this.showHelp = false
        this.showXianhuo = false
        this.showMach = false
        this.showPurchase = false
        this.isShowMyTransport = false
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {}
          })
        }
      } else if (type === '现货商城') {
        this.showXianhuo = true
        this.showHelp = false
        this.showMach = false
        this.showPurchase = false
        this.isShowMyTransport = false
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {
              type: 'showXianhuo'
            }
          })
        }
      } else if (type === '帮我采') {
        this.showXianhuo = false
        this.showHelp = true
        this.showMach = false
        this.showPurchase = false
        this.isShowMyTransport = false
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {
              type: 'showHelp'
            }
          })
        }
      } else if (type === '帮我加工') {
        this.showXianhuo = false
        this.showHelp = false
        this.showMach = true
        this.showPurchase = false
        this.isShowMyTransport = false
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {
              type: 'showMach'
            }
          })
        }
      } else if (type === '帮我找货') {
        this.showXianhuo = false
        this.showHelp = false
        this.showMach = false
        this.showPurchase = true
        this.isShowMyTransport = false
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {
              type: 'showPurchase'
            }
          })
        }
      } else if (type === '帮我运') {
        this.showXianhuo = false
        this.showHelp = false
        this.showMach = false
        this.showPurchase = false
        this.isShowMyTransport = true
        if (from !== 'route') {
          this.$router.push({
            name: 'mySteelMall',
            query: {
              type: 'isShowMyTransport'
            }
          })
        }
      }
    },
    helpMeTranslate () {
      if (this.isRegister) {
        this.switchType('帮我运')
        // this.isShowMyTransport = true
        // this.showMach = false
        // this.showXianhuo = false
        // this.showHelp = false
        // this.showPurchase = false
      } else {
        window.location.href = pubilshSet.userCenterHostUrl + 'login?refirectUrl=mySteelMall'
      }
    },
    getCoupon (item) {
      this.$axiox.get(`/baigang/buyer/couponCenter/getCoupon/${item.id}`).then(p => {
        if (p) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '领取成功',
            stayTime: 5
          })
          this.getCouponList()
        }
      })
    },
    // 获取优惠券
    getCouponList () {
      let data = {
        currPage: 1,
        pageSize: 9999
      }
      this.$axiox.post('/baigang/buyer/couponCenter/queryCouponList', data).then(msg => {
        this.couponList = msg.data.list
      })
    },
    // 获取交易动态
    async getTradingNews (num) {
      this.tradingNewsList = []
      let data = await this.$axiox.get('/baigang/shop/app/order/queryDynamicTrans')
      this.tradingNewsList = data.data
    },
    toTop () {
      if (document.getElementById('index')) {
        console.log(document.getElementById('index').scrollTop)
        document.getElementById('index').scrollTop = 0
      }
    },
    toSearch (page) {
      window.open(pubilshSet.bgSearchHostUrl + page)
    },
    toCenterUrl (page) {
      window.open(pubilshSet.userCenterHostUrl + page)
    },
    toHelp (item, childItem) {
      const newData = this.$router.resolve({
        name: 'helpDetail',
        query: {
          id: item.id,
          subId: childItem.id
        }
      })
      window.open(newData.href)
    },
    getHelpList () {
      this.$axiox.post('/baigang/shop/question/query').then(p => {
        this.handleHelpList(p.data)
      })
    },
    async handleHelpList (list) {
      for (let i = 0; i < list.length; i++) {
        let data = await this.$axiox.post('/baigang/shop/question/queryDetail/' + list[i].id)
        list[i].childrenList = data.data
      }
      this.helpList = list.slice(0, 3)
    },
    openResult () {
      const newData = this.$router.resolve({
        name: 'SteelMallResult'
      })
      window.open(newData.href)
    },
    gethangqingList (cityCode, index) {
      if ((index || index === '') || index === 0) {
        this.cityIndex = index
      }
      const data = {
        priceDate: this.$commonJs.returnDate(this.$commonJs.todayDate, 'YYMMDDHeng'),
        cityCode: cityCode || '',
        currentPage: 1,
        pageSize: 50
      }
      this.$axiox.post('/baigang/shop/shopPriceSet/queryPage', data).then(msg => {
        this.hangqingList = msg.data.list
        this.$nextTick(p => {
          this.moveLeftStart()
        })
      })
    },
    openGoodDetail (item) {
      const newData = this.$router.resolve({
        name: 'myGoodsDetail',
        query: {
          id: item.id
        }
      })
      window.open(newData.href)
    },
    showDetailFun (item) {
      this.showDetail2 = true
      let wareData = this.WarehouseList.find(p => {
        return p.id === item.warehouseId
      })
      console.log(wareData)
      if (wareData) {
        this.$nextTick(p => {
          // eslint-disable-next-line no-undef
          map = new AMap.Map('container', {
            resizeEnable: true,
            center: [parseFloat(wareData.longitude), parseFloat(wareData.latitude)],
            zoom: 13
          })
          clearMarker()
          addMarker(parseFloat(wareData.longitude), parseFloat(wareData.latitude), wareData.name)
        })
      }
    },
    // 获取列表
    getHangqingCityAllList (page) {
      this.$axiox.post('/baigang/shop/shopPriceSet/queryPageCity', { currPage: 1, pageSize: 9999 }).then(msg => {
        this.CityAllList = msg.data.list
      })
    },
    moveLeftStart () {
      if (this.hangqingList.length > 5) {
        let width = document.getElementById('moveLeft').clientWidth
        timeInter = setInterval(p => {
          if (this.isMove) {
            if ((width - (this.hangqingList.length % 4 * 285)) > this.moveLeft) {
              this.moveLeft++
            } else {
              this.moveLeft = 0
            }
          }
        }, this.hangqingList.length * 30 / 8)
      }
    },
    async getRamdonList (num) {
      let data = await this.$axiox.get('/baigang/shop/good/randomGet/' + num + '?categorySecond=' + (this.firstCate.categoryId || '') + '&publishChannel=2')
      this.firstCateList = data.data
    },
    async getRamdonList2 (num) {
      let data = await this.$axiox.get('/baigang/shop/good/randomGet/' + num + '?publishChannel=2')
      this.secCateList = data.data
    },
    async getRamdonList4 (num) {
      let data = await this.$axiox.get('/baigang/shop/good/randomGet/' + num + '')
      // console.log('+++++++++++++++++++++++++')
      // console.log(data)
      let html = ''
      let youxuanIndex = data.data.length > 4 ? 4 : data.data.length
      for (let i = 0; i < youxuanIndex; i++) {
        if (data.data[i].publishChannel === '2') {
          html += `<li>
                        <div>
                          <p class="f_w NoWrap">${data.data[i].categorySecondName}</p>
                          <p>
                            <span class="m_r_10 colorGray959595">计重方式</span><abbr class="f_w m_r_10">${{ '1': '理计', '2': '磅计', '3': '理计/磅计' }[data.data[i].settlementType] || '-'}</abbr>
                            <span class="m_r_10 colorGray959595 m_l_10">产地</span><abbr class="f_w">${data.data[i].originPlaceName || '-'}</abbr>
                          </p>
                        </div>
                        <div class="font20 colorRede31d1a">价格：${(this.isRegister && this.baigangToken) ? data.data[i].lisuanPrice : '**'}</div>
                        <div class="f_w">库存：${(this.isRegister && this.baigangToken) ? data.data[i].stock : '**'}</div>
                        <div>
                          <p class="colorGray959595">${data.data[i].guige}</p>
                        </div>
                        <div class="t_r">
        <!--                  <button class="BgcancelButton_Red"><span>查看详情</span></button>-->
                          <a target="_blank" href="${pubilshSet.searchHostUrl}myGoodsDetail?id=${data.data[i].id}"><button class="redButton"><span>查看详情</span></button></a>
                        </div>
                      </li>`
        }
      }
      if (document.getElementById('jingxuanList')) {
        document.getElementById('jingxuanList').innerHTML = html
        if (data.data.length > 4) {
          youxuanTime = setInterval(p => {
            youxuanIndex++
            if (youxuanIndex > data.data.length - 1) {
              youxuanIndex = 5
            }
            let dom = document.createElement('li')
            dom.style.transform = 'translateX(-20px)'
            dom.style.opacity = '0'
            dom.classList.add('newMoveRight')
            dom.innerHTML = `<div>
                              <p class="f_w NoWrap">${data.data[youxuanIndex].categorySecondName}</p>
                              <p>
                                <span class="m_r_10 colorGray959595">计重方式</span><abbr class="f_w m_r_10">${{ '1': '理计', '2': '磅计', '3': '理计/磅计' }[data.data[youxuanIndex].settlementType] || '-'}</abbr>
                                <span class="m_r_10 colorGray959595 m_l_10">产地</span><abbr class="f_w">${data.data[youxuanIndex].originPlaceName || '-'}</abbr>
                              </p>
                            </div>
                            <div class="font20 colorRede31d1a">价格：${this.isRegister && parseInt(this.MemberInfo.account && this.MemberInfo.account.companyAuth) === 2 ? data.data[youxuanIndex].lisuanPrice : '**'}</div>
                            <div class="f_w">库存：${this.isRegister && parseInt(this.MemberInfo.account && this.MemberInfo.account.companyAuth) === 2 ? data.data[youxuanIndex].stock : '**'}</div>
                            <div>
                              <p class="colorGray959595">${data.data[youxuanIndex].guige}</p>
                            </div>
                            <div class="t_r">
            <!--                  <button class="BgcancelButton_Red"><span>查看详情</span></button>-->
                              <a target="_blank" href="${pubilshSet.searchHostUrl}myGoodsDetail?id=${data.data[youxuanIndex].id}"><button class="redButton"><span>查看详情</span></button></a>
                            </div>`
            document.getElementById('jingxuanList').removeChild(document.getElementById('jingxuanList').firstChild)
            document.getElementById('jingxuanList').appendChild(dom)
            setTimeout(p => {
              document.querySelectorAll('.newMoveRight')[0].style.transform = 'translateX(0px)'
              document.querySelectorAll('.newMoveRight')[0].style.opacity = '1'
              document.querySelectorAll('.newMoveRight')[0].classList.remove('newMoveRight')
            }, 100)
          }, 5000)
        }
      }
    },
    async getRamdonList3 (categoryId) {
      let data = await this.$axiox.get('/baigang/shop/good/randomGet/4?futuresFlag=0&categorySecond=' + categoryId[0].categoryId + '&publishChannel=2')
      let data2 = await this.$axiox.get('/baigang/shop/good/randomGet/4?futuresFlag=0&categorySecond=' + categoryId[1].categoryId + '&publishChannel=2')
      let data3 = await this.$axiox.get('/baigang/shop/good/randomGet/4?futuresFlag=0&categorySecond=' + categoryId[2].categoryId + '&publishChannel=2')
      console.log('data', data)
      console.log('data2', data2)
      console.log('data3', data3)
      // console.log(categoryId, 'categoryId[0]');
      this.randomFuture.cateName = categoryId[0].categorySecondName
      this.randomFuture.list = data.data
      this.randomFuture2.cateName = categoryId[1].categorySecondName
      this.randomFuture2.list = data2.data
      this.randomFuture3.cateName = categoryId[2].categorySecondName
      this.randomFuture3.list = data3.data
    },
    getNoticeDetail (item) {
      console.log(item)
      this.$axiox.get('/baigang/app/home/queryNoticeInfo/' + item.noticeId).then(p => {
        this.noticeDetail = p.data
        this.showNoticeDetail = true
      })
    },
    getPlatNotice (item) {
      console.log(item)
      this.platNotice.title = ''
      this.platNotice.content = item.content
      this.platNotice.createTime = item.createTime
      this.showPlatNotice = true
    },
    toUrl2 (item) {
      window.open(item.url)
    },
    getNotice () {
      this.$axiox.get('/baigang/app/home/queryReleaseList').then(p => {
        this.noticeList = p.data
        // this.noticeHtml = ''
        // for (let i = 0; i < this.noticeList.length; i++) {
        //   this.noticeHtml += this.noticeList[i].title + ' '
        // }
      })
    },
    toLogin () {
      window.location.href = pubilshSet.userCenterHostUrl + 'login?refirectUrl=mySteelMall'
    },
    getMyMessage () {
      this.$axiox.post('/baigang/shop/msg/queryMsgPage', { currPage: 1, pageSize: 5 }).then(p => {
        console.log(p)
        this.myMessageList = p.data.list
      })
    },
    getBannerList () {
      this.$axiox.get('/baigang/app/home/queryBannerList/' + 1).then(p => {
        this.bannerList = []
        this.linkList = []
        for (let i = 0; i < p.data.length; i++) {
          if (!(i === 2 || i === 3)) {
            this.bannerList.push(p.data[i].imgUrl)
            this.linkList.push(p.data[i].link)
          }
        }
        this.showImg = true
      })
    },
    getCategoryList (id, parentId) {
      let data = {
        level: ''
      }
      this.$axiox.post('/baigang/app/good/queryCategoryList', data).then(msg => {
        this.firstCate = msg.data[0]
        console.log('msg.data', msg.data)
        this.getRamdonList(9)
        let randomId = Math.floor(Math.random() * (msg.data.length - 1))
        let randomId2 = Math.floor(Math.random() * (msg.data.length - 1))
        let randomId3 = Math.floor(Math.random() * (msg.data.length - 1))
        this.getRamdonList3([msg.data[randomId], msg.data[randomId2], msg.data[randomId3]])
        if (msg.data) {
          for (let i = 0; i < msg.data.length; i++) {
            if (msg.data[i].parentId === null) {
              this.allCategoryfatherList.push(msg.data[i])
            } else {
              this.allCategoryList.push(msg.data[i])
            }
            for (let j = 0; j < this.allCategoryfatherList.length; j++) {
              this.$set(this.allCategoryfatherList[j], 'childList', [])
            }
          }
          for (let i = 0; i < this.allCategoryfatherList.length; i++) {
            this.onSeltCate(this.allCategoryfatherList[i], i)
          }
        }
      })
    },
    onSeltCate (item, index) {
      this.allCategoryfatherList[index].childList = []
      for (let i = 0; i < this.allCategoryList.length; i++) {
        if (this.allCategoryList[i].parentId === item.categoryId) {
          this.allCategoryfatherList[index].childList.push(this.allCategoryList[i])
        }
      }
    },
    toUrl (url, item, type) {
      if (!type) {
        this.$router.push({
          name: url,
          query: {
            categoryId: item.categoryId
          }
        })
      }
      if (type === 1) {
        this.$router.push({
          name: url,
          query: {
            materId: item.id
          }
        })
      }
      if (type === 2) {
        this.$router.push({
          name: url,
          query: {
            chandiId: item.id
          }
        })
      }
    }
  }
}
function clearMarker () {
  if (marker) {
    marker.setMap(null)
    marker = null
  }
}
function addMarker (x, y, name) {
  // eslint-disable-next-line no-undef
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: [x, y],
    // eslint-disable-next-line no-undef
    offset: new AMap.Pixel(-13, -30)
  })
  var markerContent = document.createElement('div')

  // 点标记中的图标
  var markerImg = document.createElement('img')
  markerImg.className = 'markerlnglat'
  markerImg.src = '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png'
  markerContent.appendChild(markerImg)

  // 点标记中的文本
  var markerSpan = document.createElement('span')
  markerSpan.className = 'marker'
  markerSpan.innerHTML = name
  markerContent.appendChild(markerSpan)
  marker.setContent(markerContent)
  marker.setMap(map)
}
</script>

<style scoped>
.searchBlock {
  width: 600px;
  height: 40px;
  border: 1px solid #d71e1e;
  border-radius: 4px;
}
.searchBlock input {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 4px 0px 0px 4px;
  padding: 0 10px;
}
.searchBlock div {
  padding-left: 10px;
  padding-right: 9px;
  height: 100%;
  background: #d71e1e;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}
.no-ul {
  justify-content: flex-start !important;
  align-content: flex-start !important;
}
.no-ul li {
  box-sizing: border-box;
  width: 33.3% !important;
}
.btService {
  min-height: 314px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/mySteelMall.vue